import styled from 'styled-components'

const StyledAppointmentTag = styled.div`
  display: inline-block;
  &.dark-calendar {
    color: #ffffff !important;
    .ant-descriptions-item-label span {
      color: #ffffff !important;
    }
  }
  &.styled_OPEN {
    color: #1890ff;
    background-color: #e6f7ff;
    border-color: #53a3ec;
    &.dark-calendar {
      background-color: #249ed7;
      border-color: #0b597e;
    }
  }

  &.styled_CONFIRMED {
    color: #031fa6;
    background-color: #f0f5ff;
    border-color: #3365d7;
    &.dark-calendar {
      background-color: #153e94;
      border-color: #082054;
    }
  }

  &.styled_CHECKEDIN {
    color: #13c2c2;
    background-color: #e6fffb;
    border-color: #50f1e2;
    &.dark-calendar {
      background-color: #20bea6;
      border-color: #06695a;
    }
  }

  &.styled_INPROGRESS {
    color: #722ed1;
    background-color: #f9f0ff;
    border-color: #a04def;
    &.dark-calendar {
      background-color: #681c9a;
      border-color: #32064f;
    }
  }

  &.styled_COMPLETED {
    color: #52c41a;
    background-color: #f6ffed;
    border-color: #a6f36b;
    &.dark-calendar {
      background-color: #166534;
      border-color: #05410a;
    }
  }

  &.styled_DELAYED {
    color: #fa8c16;
    background-color: #fff7e6;
    border-color: #f1b34f;
    &.dark-calendar {
      background-color: #ff8605;
      border-color: #914e0a;
    }
  }

  &.styled_CANCELED {
    color: #eb2fd8;
    background-color: #fff0f6;
    border-color: #ef54d5;
    &.dark-calendar {
      background-color: #c41c80;
      border-color: #810f53;
    }
  }

  &.styled_NOSHOW {
    color: #cf1322;
    background-color: #fff1f0;
    border-color: #ef817b;
    &.dark-calendar {
      background-color: #640f09;
      border-color: #3f0905;
    }
  }

  &.styled_WAITING {
    color: #d4b106;
    background-color: #feffe6;
    border-color: #fffb8f;
    &.dark-calendar {
      background-color: #b1b71a;
      border-color: #737905;
    }
  }

  &.styled_NOTE {
    color: #3f3f3f;
    background-color: #fafafa;
    border-color: #afafaf;
    &.dark-calendar {
      background-color: #868686;
      border-color: #414141;
    }
  }

  &.styled_CHECKEDOUT {
    color: #0a9a00;
    background-color: #caffc8;
    border-color: #6eff65;
    &.dark-calendar {
      background-color: #0ee600;
      border-color: #00c225;
    }
  }

  &.styled_ROW {
    color: #1d39c4;
    background-color: #f8f9fc;
    border-color: #adc6ff;
  }

  &.inline {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 6px;
  }
`

export default StyledAppointmentTag
